import React from 'react';
import Button from "../../components/button/Button";
import Meta from "../../components/Meta";

const BookReview = () => {

  return (
    <section className="book-review pt-40">

      <Meta
        title="Grokking Concurrency"
        desc="A visual, beginner-friendly guide to concurrency by Kirill Bobrov"
        image="/images/books/grokking-concurrency.jpg"
        pageType="book"
        author="Kirill Bobrov"
      />

      <section className="relative">
        <div className="container ">
          <div className="justify-between lg:flex lg:space-x-20">
            <div className="min-w-fit">
              <img
                src="/images/books/grokking-concurrency.jpg"
                width="400"
                className="shadow-lg"
              />
              <div className="text-center mt-10">
                <Button title="Read with us" link="/pricing"/>
              </div>
            </div>
            <div className="lg:pr-25">
              <h1 className="font-display text-jacarta-700 text-4xl font-medium dark:text-white">
                Grokking Concurrency
              </h1>
              <h2 className="dark:text-jacarta-60 text-lg leading-normal mb-5">
                By <strong>Kirill Bobrov</strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                Concurrency is one of the most challenging topics in software engineering, and
                Kirill Bobrov makes it approachable. This book breaks down the fundamental
                concepts behind concurrent and parallel programming — threads, locks, race
                conditions, and synchronization — using clear explanations and visual diagrams
                that make complex ideas click.
              </p>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                Rather than diving straight into language-specific APIs, the book focuses on
                building a solid mental model of how concurrent systems work. You will understand
                why certain bugs are so hard to reproduce, what trade-offs come with different
                concurrency models, and how operating systems manage parallel execution under the
                hood. A great read for any engineer who wants to write safer, more performant code.
              </p>

            </div>
          </div>
        </div>
      </section>

    </section>
  );
};

export default BookReview;
